"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _endpoints = require("./endpoints.js");
var _uuid = require("uuid");
async function _default(token, imgData, locale, metadata) {
  const imageId = (0, _uuid.v4)();
  try {
    const response = await fetch(`${_endpoints.ecardUrl}/ecards`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        images: [{
          data: imgData,
          locale: locale,
          id: imageId,
          metadata: metadata
        }],
        type: 'CUSTOM',
        status: 'ACTIVE',
        defaultImageId: imageId
      })
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      const error = await response.json();
      return error;
    }
  } catch (error) {
    console.log(error);
    return error;
  }
}
//# sourceMappingURL=ecards.js.map